import axios from "axios";
import { removeTokens } from "../utils/sessionMethods";
import { toast } from "react-toastify";

const getUrlApi = () => {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3000/api/v0";
  } else {
    // return `https://api.${process.env.REACT_APP_COMPANY_KEY}.x-pay.app/api/v0`
    return process.env.REACT_APP_URL_API;
  }
};

export const apiUrl = getUrlApi();
//export const apiUrl = 'https://api.fomento.x-pay.app/api/v0'

const api = axios.create({
  // headers: {
  //   Authorization: localStorage.getItem("token"),
  //   device: localStorage.getItem("deviceId"),
  // }, // FIX: Device
  baseURL: apiUrl, // backend
  //baseURL: 'http://localhost:3000/api/v0' //api
});

api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("access_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

const tryRefreshToken = async () => {
  const token = sessionStorage.getItem("refresh_token");

  return axios
    .get(`${apiUrl}/login/token`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      sessionStorage.setItem("access_token", response.data.accessToken);
      sessionStorage.setItem("refresh_token", response.data.refreshToken);
    });
};

async function error401handling(error) {
  await tryRefreshToken()
    .then(() => api(error.config))
    .catch(() => {
      console.log(err);
      removeTokens();
      toast.warning("Sessão expirada, entre novamente.");

      setTimeout(() => {
        document.location.href = "/";
      }, 5000);
    });
  return Promise.reject(error);
}

const ignoredRoutes = ["/login/auth"];

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      !ignoredRoutes.includes(error.config.url) &&
      error.response.status === 401
    ) {
      console.log(error);
      removeTokens();
      toast.warning("Sessão expirada, entre novamente.");

      setTimeout(() => {
        return document.location.href = "/";
      }, 5000);
    }

    return Promise.reject(error);
  }
);

export default api;
